module.exports = __webpack_public_path__ + "img/video-call-bubble.d44bc483.svg";